import { render } from "./BattlesTableView.vue?vue&type=template&id=adb460e6"
import script from "./BattlesTableView.vue?vue&type=script&lang=js"
export * from "./BattlesTableView.vue?vue&type=script&lang=js"

import "./BattlesTableView.vue?vue&type=style&index=0&id=adb460e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__